import React from 'react'
import IncentiveMultiSelectList from '../baseComponents/incentiveMultiSelectList/IncentiveMultiSelectList';

export const KpiSelection = (props: { stateName: string }) => {
    const listOptions = [
        'Cross Sell', 'Recover', 'Sales Target', 'Focus Product'
    ]
    return (
        <IncentiveMultiSelectList listOptions={listOptions} stateName={props.stateName}  displayPoints={true}/>
    )
}
